import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { CustomEventDTO, CustomEventPayload } from "../types/dtos";

export const eventsApi = createApi({
  reducerPath: "eventsApi",
  baseQuery: fetchBaseQuery({ baseUrl: "/api/customevents/" }),
  tagTypes: ["Events"],
  endpoints: (builder) => ({
    getEventById: builder.query({
      query: (id) => `${id}`,
      providesTags: (result, error, id) => [{ type: "Events", id }],
    }),
    createEvent: builder.mutation({
      query: (event) => ({
        url: "",
        method: "POST",
        body: event,
      }),
      invalidatesTags: [{ type: "Events" }],
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          const { bumpReloadSeq } = await import(
            "@/app/_store/slices/calendarUiSlice"
          );
          dispatch(bumpReloadSeq());
        } catch {}
      },
    }),

    updateEvent: builder.mutation<
      CustomEventDTO,
      { id: number; data: CustomEventPayload }
    >({
      query: ({ id, data }) => ({
        url: `${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: "Events", id }],
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          const { bumpReloadSeq } = await import(
            "@/app/_store/slices/calendarUiSlice"
          );
          dispatch(bumpReloadSeq());
        } catch {}
      },
    }),
    deleteEvent: builder.mutation({
      query: (id) => ({
        url: `${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, id) => [{ type: "Events", id }],
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          const { bumpReloadSeq } = await import(
            "@/app/_store/slices/calendarUiSlice"
          );
          dispatch(bumpReloadSeq());
        } catch {}
      },
    }),
  }),
});

export const {
  useGetEventByIdQuery,
  useCreateEventMutation,
  useUpdateEventMutation,
  useDeleteEventMutation,
} = eventsApi;
